import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    backArrow: { width: '50px' },
    anchorText: {
        textDecorationLine: 'none' as const,
        color: theme?.app?.applicationColors.fontAnchorColor ||
            '#547dbf'
    },
    itemTitle: {
        height: '24px',
        width: '40px',
        paddingTop: '.75rem'
    },
    topContent: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        paddingLeft: '1.5rem',
        paddingTop: '2.8rem',
        paddingRight: '.5rem',
        paddingBottom: '1rem',
        flexBasis: 'auto'
    },
    balanceLabel: {
        fontSize: '.8rem',
        color: theme?.app?.applicationColors.enumColors.grey ||
            '#888888',
        textTransform: 'uppercase' as const
    },
    balanceValue: {
        fontSize: '3rem',
        color: theme?.app?.applicationColors.fontColor ||
            '#202020',
        paddingTop: '.75rem'
    },
    historyContainer: { flexGrow: 1 }
});